import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";

const {
  colors: { ui },
} = constants;

export const linkContainerCss: CSSObject = {
  display: "flex",
  flexDirection: "row",
  gap: "8px",
  flexWrap: "wrap",
};

export const linkCss: CSSObject = {
  padding: "8px",
  textDecoration: "none",
  color: ui.white[500],
  background: ui.neutral[600],
  opacity: 0.4,
  borderRadius: 100,
};

export const activeLinkCss: CSSObject = {
  opacity: 1,
};
